export interface ConfidenceFeature {
  icon: string;
  title: string;
  description: string;
  linkText: string;
  linkHref: string;
}

export const confidenceFeatures: ConfidenceFeature[] = [
  {
    icon: "ri-shield-check-line",
    title: "正品保證",
    description:
      "所有貨源均經過平台專業鑑定團隊審核，附正品證書與溯源報告，認購無須擔憂品質。",
    linkText: "了解更多",
    linkHref: "/faq",
  },
  {
    icon: "ri-refund-line",
    title: "未達標全額退款",
    description:
      "認購目標未達標即自動全額退款，資金原路退回，零風險參與每一筆認購。",
    linkText: "退款政策",
    linkHref: "/faq",
  },
  {
    icon: "ri-bar-chart-grouped-line",
    title: "透明收益追蹤",
    description:
      "個人中心即時顯示庫存、銷售價與利潤，每一步都清晰可見。",
    linkText: "查看詳情",
    linkHref: "/dashboard",
  },
];